import { INovaUserAuthHeaders, IUserGameplayData } from '@nova/types';
import axios from 'axios';

import { IUserLoadout } from '../interfaces';

export async function equipUserLoadout(gameAPIEndpoint: string, authHeaders: INovaUserAuthHeaders, loadout: IUserLoadout): Promise<IUserGameplayData | null> {
  if (!loadout) { return null; }

  const path = `user-loadouts/equip-in-match-prep-lobby`;

  try {
    const response = await axios.patch<IUserGameplayData>(`${gameAPIEndpoint}/${path}`, loadout, {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        ...authHeaders
      },
      data: loadout
    });
    return response.data;
  }
  catch {
    return null;
  }
}
